import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import CrownImg from '@src/assets/images/crown.png';
import usePaywallTracking from '@src/hooks/usePaywallTracking';
import { MOE_PAYWALL_CTA, MOE_PAYWALL_TYPE } from '@src/constants/moengage';

const OutOfCreditsFree = ({ open, onClose }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const { trackCta } = usePaywallTracking({
    paywallType: MOE_PAYWALL_TYPE.OUT_OF_CREDITS,
  });

  const handleUpgradeNow = () => {
    trackCta(MOE_PAYWALL_CTA.UPGRADE);
    history.push(ROUTES.PAYMENT);
  };

  const renderUpgradeButton = () => (
    <Button variant="contained" onClick={handleUpgradeNow}>
      {t('upgradePackage')}
    </Button>
  );

  return (
    <NotificationDialogV4
      image={CrownImg}
      title={t('outOfCredits')}
      description={t('descriptionOutOfCreditsFree')}
      actionComponent={renderUpgradeButton()}
      open={open}
      onClose={onClose}
    />
  );
};

export default OutOfCreditsFree;
